import React, { useMemo } from 'react';
import { ArrowRight } from 'lucide-react';
function Snowflake({
  style
}: {
  style: React.CSSProperties;
}) {
  return <div className="absolute rounded-full bg-white pointer-events-none" style={style} data-id="element-2" />;
}
function SnowEffect() {
  const snowflakes = useMemo(() => {
    return Array.from({
      length: 30
    }, (_, i) => {
      const size = Math.random() * 4 + 2; // 2-6px
      const left = Math.random() * 100; // 0-100%
      const animationDuration = Math.random() * 10 + 10; // 10-20s
      const animationDelay = Math.random() * -20; // stagger start
      const opacity = Math.random() * 0.4 + 0.3; // 0.3-0.7
      const drift = Math.random() * 40 - 20; // -20 to 20px horizontal drift
      return {
        id: i,
        style: {
          width: size,
          height: size,
          left: `${left}%`,
          top: -10,
          opacity,
          animation: `snowfall ${animationDuration}s linear ${animationDelay}s infinite`,
          '--drift': `${drift}px`
        } as React.CSSProperties
      };
    });
  }, []);
  return <div className="fixed inset-0 overflow-hidden pointer-events-none z-0" data-id="element-3">
      <style data-id="element-4">{`
        @keyframes snowfall {
          0% {
            transform: translateY(-10px) translateX(0);
          }
          50% {
            transform: translateY(50vh) translateX(var(--drift));
          }
          100% {
            transform: translateY(100vh) translateX(0);
          }
        }
      `}</style>
      {snowflakes.map(flake => <Snowflake key={flake.id} style={flake.style} data-id="element-5" />)}
    </div>;
}
export function LandingPage() {
  return <main className="min-h-screen w-full bg-black text-white selection:bg-sky-400 selection:text-white flex flex-col items-center justify-center p-6 sm:p-12 relative" data-id="element-6">
      <SnowEffect data-id="element-7" />

      <div className="max-w-4xl w-full flex flex-col items-center text-center space-y-16 sm:space-y-20 relative z-10" data-id="element-8">
        {/* Hero Section */}
        <header className="space-y-8" data-id="element-9">
          <h1 className="text-7xl sm:text-9xl font-bold tracking-tighter leading-none" data-id="element-10">
            SNOWBALL
          </h1>
          <p className="text-xl sm:text-2xl text-neutral-400 font-light tracking-wide max-w-xl mx-auto" data-id="element-11">
            Backing exceptional founders building the future.
          </p>
        </header>

        {/* Philosophy Section - Minimal */}
        <section className="max-w-2xl mx-auto space-y-6" data-id="element-12">
          <p className="text-lg sm:text-xl text-neutral-300 leading-relaxed font-light" data-id="element-13">
            A snowball has unlimited potential. So do the best founders in the world. We back them first.
          </p>
        </section>

        {/* CTA Section */}
        <div data-id="element-14">
          <a href="mailto:hello@snowball.vc" className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white transition-all duration-300 ease-out bg-sky-500 rounded-full hover:bg-sky-400 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:ring-offset-2 focus:ring-offset-black" aria-label="Get in touch with Snowball VC" data-id="element-15">
            <span data-id="element-16">Get in Touch</span>
            <ArrowRight className="w-5 h-5 ml-2 transition-transform duration-300 group-hover:translate-x-1" data-id="element-17" />
          </a>
        </div>

        {/* Footer / Copyright - Extremely subtle */}
        <footer className="pt-12 text-sm text-neutral-800 font-mono" data-id="element-18">
          © {new Date().getFullYear()} SNOWBALL VENTURES
        </footer>
      </div>
    </main>;
}